// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import auditStatusEntity from './entities/audit-status.json';
import auditStatusMenu from '../pages/audit-status/menu.json';
import auditStatusFullForm from '../pages/audit-status/forms/full.json';
import auditStatusContextForm from '../pages/audit-status/forms/context.json';
import auditStatusMiniForm from '../pages/audit-status/forms/mini.json';
import auditStatusLookupForm from '../pages/audit-status/forms/lookup.json';
import auditStatusTableView from '../pages/audit-status/views/table.json';
import auditStatusDashboardView from '../pages/audit-status/views/dashboard.json';

/** Тип запису «Етап аудиту» зі сторінками пакета: меню, форми та подання з pages/audit-status/. */
export const auditStatusDefinition: IRecordTypeDefinition = {
  ...auditStatusEntity,
  views: assembleViewSet({
      table: auditStatusTableView,
      dashboard: auditStatusDashboardView,
  }),
  form: auditStatusFullForm,
  forms: { full: auditStatusFullForm, context: auditStatusContextForm, mini: auditStatusMiniForm, lookup: auditStatusLookupForm },
  menu: auditStatusMenu,
} as IRecordTypeDefinition;
